import { createSelector } from 'reselect';
import { selectOptions } from '../ActiveGame/selectors';
import { sourceOption, stepTargets } from '../ActiveGame/options';

const selectDomain = (state) => state.picks;

export const selectPicksSource = createSelector([selectDomain], (state) => state.get('source'));

export const selectPicksSteps = createSelector([selectDomain], (state) => state.get('steps'));

export const selectPicksMade = createSelector([selectDomain], (state) => state.get('picks'));

/** The step the player is on, or null once every pick is made. */
export const selectPicksStep = createSelector(
  [selectPicksSteps, selectPicksMade],
  (steps, picks) => steps.get(picks.size) || null,
);

export const selectPicksChoosing = createSelector([selectDomain], (state) => state.get('choosing'));

export const selectSubmittingPicks = createSelector([selectDomain], (state) => state.get('submitting'));

/** What the current step can pick, from the server's options: spots, card positions or energy types. */
export const selectStepTargets = createSelector(
  [selectOptions, selectPicksSource, selectPicksMade, selectPicksStep],
  (options, source, picks, step) => (
    source === null || step === null ? [] : stepTargets(sourceOption(options, source), picks.size)
  ),
);
